import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/category/:slug',
    name: 'submenu',
    component: () => import(/* webpackChunkName: "submenu" */ '../views/Submenu.vue'),
  },
  {
    path: '/auth/redirect',
    name: 'sso',
    component: () => import(/* webpackChunkName: "sso" */ '../views/Sso.vue'),
  },
  {
    path: '/landing/amway-social-selling',
    name: 'landigPage',
    component: () => import(/* webpackChunkName: "landigPage" */ '../views/LandigPage.vue'),
  },
  {
    path: '/landing/amway-social-selling/page/1',
    name: 'landigPage',
    component: () => import(/* webpackChunkName: "landigPage" */ '../views/LandigPage1.vue'),
  },
  {
    path: '/landing/amway-social-selling/page/2',
    name: 'landigPage',
    component: () => import(/* webpackChunkName: "landigPage" */ '../views/LandigPage2.vue'),
  },
  {
    path: '/landing/amway-social-selling/page/3',
    name: 'landigPage',
    component: () => import(/* webpackChunkName: "landigPage" */ '../views/LandigPage3.vue'),
  },
  {
    path: '/landing/amway-social-selling/page/4',
    name: 'landigPage',
    component: () => import(/* webpackChunkName: "landigPage" */ '../views/LandigPage4.vue'),
  },
  {
    path: '/landing/atmosphere-mini',
    name: 'atmosphereMini',
    component: () => import(/* webpackChunkName: "atmosphereMini" */ '../views/AtmMini.vue'),
  },
  {
    path: '/p/:uuid',
    name: 'read',
    component: () => import(/* webpackChunkName: "read" */ '../views/Category.vue'),
  },
  {
    path: '/embed/:slug',
    name: 'embed',
    component: () => import(/* webpackChunkName: "embed" */ '../views/Embed.vue'),
  },
  {
    path: '/:parent/:slug',
    name: 'read',
    component: () => import(/* webpackChunkName: "read" */ '../views/Read.vue'),
  },
  {
    path: '/:parent',
    name: 'category',
    component: () => import(/* webpackChunkName: "category" */ '../views/Category.vue'),
  },
  {
    path: '/:parent/edition/:year',
    name: 'category',
    component: () => import(/* webpackChunkName: "category" */ '../views/Category.vue'),
  },
  {
    path: '*',
    name: 'notFound',
    component: () => import(/* webpackChunkName: "notFound" */ '../views/NotFound.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

// router.beforeEach((to, from, next) => {
//   const { app }: any = router;
//   if (to.fullPath === '/profile/history') {
//     if (!app.$session.exists()) {
//       next('/');
//       return;
//     }
//   }
//   next();
// });

export default router;
